<template>
  <div v-if="icon || title" :class="`alert-amo ${type}`">
    <i v-if="icon" :class="`icon mdi mdi-${icon}`"></i>
    <span v-if="title">{{title}}</span>
  </div>
</template>

<script>
export default {
  name: 'Alert',
  props: {
    title: String,
    icon: String,
    type: String
  }
}
</script>

<style lang="scss">
@import "./style.scss";
</style>
